module.exports = __webpack_public_path__ + "static/media/Leash_Geometric_02.f84bf658.png";